export default __webpack_public_path__ + "img/bg_modal_card.6219e53d.svg";